import OlInteractionDraw from 'ol/interaction/draw';
import OlInteractionDoubleClickZoom from 'ol/interaction/doubleclickzoom';
import OlSourceVector from 'ol/source/vector';

class DrawInteractionManager {
    _drawInteraction = null;
    _dblClickInteraction = null;

    startDrawing = (olMap, type, geometryFunction, onDrawEnd) => {
        if (this._drawInteraction) return;

        olMap.getInteractions().getArray().forEach((interaction) => {
            if (interaction instanceof OlInteractionDoubleClickZoom) {
                this._dblClickInteraction = interaction;
            }
        });
        olMap.removeInteraction(this._dblClickInteraction);

        const tempSource = new OlSourceVector();
        this._drawInteraction = new OlInteractionDraw({
            source: tempSource,
            type: type,
            geometryFunction: geometryFunction
        });

        this._drawInteraction.on('drawend', function (event) {
            olMap.removeInteraction(this._drawInteraction);
            this._drawInteraction.stopped = true;
            this._drawInteraction = null;
            setTimeout(() => {
                olMap.addInteraction(this._dblClickInteraction);
            });

            const geom = event.feature.getGeometry();
            onDrawEnd(geom);
        }, this);
        olMap.addInteraction(this._drawInteraction);
    }

    finishDrawing = (olMap, saveFeature) => {
        if (this._drawInteraction) {
            if (this._drawInteraction.sketchCoords_ && saveFeature) {
                if (!this._drawInteraction.stopped) {
                    this._drawInteraction.finishDrawing();
                }
            } else {
                olMap.addInteraction(this._dblClickInteraction);
                olMap.removeInteraction(this._drawInteraction);
            }
            this._drawInteraction = null;
        }
    }
}

// enable to exists separate managers for map and for photoTilesGallery
const drawInteractionManagers = {};
export const getDrawInteractionManager = (managerName) => {
    if (!(managerName in drawInteractionManagers)) {
        drawInteractionManagers[managerName] = new DrawInteractionManager();
    }
    return drawInteractionManagers[managerName];
}


// WEBPACK FOOTER //
// ./src/utilities/drawInteractionManager.js